import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CompanyPresentation from './components/CompanyPresentation';
import Loading from './components/Loading';

const About = lazy(() => import('./components/About'));
const Circuits = lazy(() => import('./components/Circuits'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const FloatingContact = lazy(() => import('./components/FloatingContact'));
const CookieBanner = lazy(() => import('./components/CookieBanner'));
const Legal = lazy(() => import('./pages/Legal'));
const BookingSuccess = lazy(() => import('./components/BookingSuccess'));
const BookingCanceled = lazy(() => import('./components/BookingCanceled'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/legal/:page" element={<Suspense fallback={<Loading />}><Legal /></Suspense>} />
        <Route path="/booking/success" element={<Suspense fallback={<Loading />}><BookingSuccess /></Suspense>} />
        <Route path="/booking/canceled" element={<Suspense fallback={<Loading />}><BookingCanceled /></Suspense>} />
        <Route
          path="/"
          element={
            <div className="min-h-screen">
              <Navbar />
              <Hero />
              <CompanyPresentation />
              <Suspense fallback={<Loading />}>
                <About />
                <Circuits />
                <Testimonials />
                <Contact />
                <Footer />
                <FloatingContact />
                <CookieBanner />
              </Suspense>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;